module.exports = __webpack_public_path__ + "img/dot-dk.277e4b0e.svg";